export default [
  {
    question: `What do I need to know?`,
    answer: `Staking via Unagii delegates to the Stakewithus validator to help secure the network and receive a share of incentivized rewards earned. Rewards are earned by staking tokens and are paid out on a per block basis. Users can withdraw or compound at any time.`,
  },
  {
    question: `What is the inflation?`,
    answer: `There is high inflation with over 300 million tokens being issued during the first year. Under the initial token model, new tokens will be issued under an exponential decay schedule, where inflation will decrease every year (365 daily epochs). The target is to issue one billion EVMOS in 4 years. Newly minted tokens will be distributed on a per-block basis to Staking rewards (40%), Team vesting (25%), Usage incentives (25%) and Community Pool (10%).`,
  },
  {
    question: `Is there a lock-up period?`,
    answer: `There is a 21 days unbonding period when unstaking EVMOS from the network. Users will not earn rewards and will be susceptible to slashing during unbonding.`,
  },
  {
    question: `How to restake?`,
    answer: `Users may manually withdraw rewards and restake to compound their returns. Enabling auto-compound via REstake by Eco Stake is also an available option.`,
  },
  {
    question: `Is there a fee?`,
    answer: `There is a delegation commission fee paid to Stakewithus for staking.`,
  },
  {
    question: `What are the risks?`,
    answer: `Staking risks do apply including slashing involved for downtime and double signing.`,
  },
];
